import { PagePending } from "@/components/ui/PagePending";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { TabNav, TabNavItem } from "@/components/ui/TabNav";
import { seo } from "@/utils/seo";
import { Box } from "@givenwell/components";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/devtools")({
  pendingComponent: PagePending,
  component: DevTools,
  beforeLoad: () => ({
    breadcrumb: "Dev Tools",
  }),
  head: () => ({ meta: seo({ title: "Devtools" }) }),
});

function DevTools() {
  return (
    <PageWrapper title="Dev Tools">
      <TabNav>
        <TabNavItem
          to="/admin/devtools"
          activeOptions={{
            exact: true,
          }}
        >
          Home
        </TabNavItem>
        <TabNavItem to="/admin/devtools/airwallex">Airwallex</TabNavItem>
        <TabNavItem to="/admin/devtools/ui">UI Library</TabNavItem>
        <TabNavItem to="/admin/devtools/listing-selector">Listing Selector</TabNavItem>
        <TabNavItem to="/admin/devtools/billing-sim">Billing Sim</TabNavItem>
        <TabNavItem to="/admin/devtools/member-lookup">Member Lookup</TabNavItem>
      </TabNav>
      <Box css={{ h: 16 }} />
      <Outlet />
    </PageWrapper>
  );
}
